module.exports = __webpack_public_path__ + "img/buzzfeed-webapp-logo.0ea3c59fd2aeb164cfdfe77e74ab3aa2.png";


//////////////////
// WEBPACK FOOTER
// /~/@buzzfeed/buzzblocks/img/buzzfeed-webapp-logo.png
// module id = 41
// module chunks = 1